<div class="auth-failed-container">
    <div class="auth-failed-div">
        <p class="auth-failed-header">Applens backend did not respond. Please <strong>go back</strong> to AppLens home page & try reloading it. If the issue persists, please contact <a class="help-link" tabindex=0 href="mailto:applensv2team@microsoft.com?Subject=AppLens%20Authorization%20Request%20Failed&body=User%20Alias%3A%20%0A" target="_top">AppLens Team</a></p>
    </div>
</div>